import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ConversationAPI from '../../api/conversations';

export const state = {
  records: [],
  currentTicket: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getTickets(_state) {
    return _state.records;
  },
  getCurrentTicket(_state) {
    return _state.currentTicket;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  current: async ({ commit }, { conversationId }) => {
    try {
      const response = await ConversationAPI.getCurrentTicket(conversationId);
      // The endpoint answers with an error payload (not a ticket) when the
      // conversation is not open, so only keep an actual ticket.
      commit(
        types.SET_CONVERSATION_CURRENT_TICKET,
        response.data?.id ? response.data : null
      );
    } catch {
      commit(types.SET_CONVERSATION_CURRENT_TICKET, null);
    }
  },

  conversationResolved: ({ commit }) => {
    commit(types.SET_CONVERSATION_CURRENT_TICKET, null);
  },

  update: async (
    { commit },
    { conversationId, ticketId, customAttributes }
  ) => {
    try {
      const response = await ConversationAPI.updateTicketCustomAttributes(
        conversationId,
        ticketId,
        customAttributes
      );
      commit(types.SET_CONVERSATION_CURRENT_TICKET, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },

  deleteCustomAttributes: async (
    { commit },
    { conversationId, ticketId, customAttributes }
  ) => {
    try {
      const response = await ConversationAPI.destroyTicketCustomAttributes(
        conversationId,
        ticketId,
        customAttributes
      );
      commit(types.SET_CONVERSATION_CURRENT_TICKET, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.SET_CONVERSATION_TICKETS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CONVERSATION_CURRENT_TICKET]: ($state, data) => {
    $state.currentTicket = data;
  },
  [types.ADD_TICKET]: MutationHelpers.create,
  [types.SET_TICKETS]: MutationHelpers.set,
  [types.EDIT_TICKET]: MutationHelpers.update,
  [types.DELETE_TICKET]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
